module.exports = __webpack_public_path__ + "static/media/logo192.277bc22d.png";